export const ADD_FOOTERMENU = 'ADD_FOOTERMENU'; 
export const DELETE_FOOTERMENU = 'DELETE_FOOTERMENU';
export const ADD_FOOTERMENU_LOOP = 'ADD_FOOTERMENU_LOOP';